import React, { useState, Suspense } from 'react';
import Modal from 'components/commons/modal';
import Loading from 'components/loading';
import AuthorizeInformationAccessText from './authorize-information-access-text';

const AuthorizeInformationAccessDialog: React.FC = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <a onClick={() => setOpened(true)}>acesso às informações</a>

            <Modal
                visible={opened}
                title="Termo de Autorização para Consulta ao SCR"
                onClose={() => setOpened(false)}
            >
                <Suspense fallback={<Loading />}>
                    <AuthorizeInformationAccessText />
                </Suspense>
            </Modal>
        </>
    );
};

export default AuthorizeInformationAccessDialog;
